// extracted by mini-css-extract-plugin
module.exports = {"lastBooks":"LastBooks_lastBooks__B5YU5"};